import i18n from 'i18next';
import { IField } from 'modules/core/types';
import {
  requiredValidator,
  validateMinRequiredValueForDropdown,
  validateRequiredMinimumValue,
  validateNumberValue,
} from 'modules/core/validators';
import { Input } from 'modules/core/components';
import { MONEY_SYMBOL, PATTERNS } from 'modules/core/constants';
import { ChangeEvent } from 'react';
import { COLORS } from 'modules/core/theme/colors';
import { theme } from 'modules/core/theme';

import { ADD_VEHICLE_FIELDS_NAMES } from './fieldNames.const';
import { Dropdown } from '../../LoanVariablesDialog/components/common/Dropdown/Dropdown';
import { CONDITION_OPTIONS } from './consts';

export const ADD_VEHICLE_FIELDS: IField[] = [
  {
    name: ADD_VEHICLE_FIELDS_NAMES.VIN,
    component: Input,
    label: i18n.t('addVehicleModal.labels.vin'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      rules: {
        required: true,
        pattern: {
          value: PATTERNS.VIN_PATTERN,
        },
      },
      maxLength: 17,
      changeCallback: (event: ChangeEvent<HTMLInputElement>) => {
        event.target.value = event.target.value.toUpperCase();
      },
      valueAsNumber: false,
      isRequired: true,
      isAllowTypeSpace: false,
      placeholder: i18n.t('addVehicleModal.vin.placeholder'),
      placeholderStyles: { fontWeight: theme.boldText.normal, color: COLORS.GREY_24 },
      labelWithoutAsterisk: true,
    },
  },
  {
    name: ADD_VEHICLE_FIELDS_NAMES.CONDITION,
    component: Dropdown,
    label: i18n.t('addVehicleModal.labels.condition'),
    isVerticalAlign: true,
    controlProps: {
      options: CONDITION_OPTIONS,
      isRequired: true,
      rules: requiredValidator,
      validate: validateMinRequiredValueForDropdown,
      placeholder: i18n.t('components.loanVariablesModal.modals.netTradeIn.selectPlaceholder'),
      labelWithoutAsterisk: true,
    },
  } as IField,
  {
    name: ADD_VEHICLE_FIELDS_NAMES.MAKE,
    component: Dropdown,
    label: i18n.t('addVehicleModal.labels.make'),
    isVerticalAlign: true,
    controlProps: {
      options: [],
      isRequired: true,
      rules: requiredValidator,
      validate: validateMinRequiredValueForDropdown,
      placeholder: i18n.t('components.loanVariablesModal.modals.netTradeIn.selectPlaceholder'),
      labelWithoutAsterisk: true,
    },
  } as IField,
  {
    name: ADD_VEHICLE_FIELDS_NAMES.MODEL,
    component: Dropdown,
    label: i18n.t('addVehicleModal.labels.model'),
    isVerticalAlign: true,
    controlProps: {
      options: [],
      isRequired: true,
      rules: requiredValidator,
      validate: validateMinRequiredValueForDropdown,
      placeholder: i18n.t('components.loanVariablesModal.modals.netTradeIn.selectPlaceholder'),
      labelWithoutAsterisk: true,
    },
  } as IField,
  {
    name: ADD_VEHICLE_FIELDS_NAMES.TRIM,
    component: Input,
    label: i18n.t('addVehicleModal.labels.trim'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      maxLength: 70,
      isRequired: true,
      valueAsNumber: false,
      placeholder: i18n.t('addVehicleModal.labels.trim'),
      placeholderStyles: { fontWeight: theme.boldText.normal, color: COLORS.GREY_24 },
      labelWithoutAsterisk: true,
    },
  },
  {
    name: ADD_VEHICLE_FIELDS_NAMES.YEAR,
    component: Dropdown,
    label: i18n.t('addVehicleModal.labels.year'),
    isVerticalAlign: true,
    controlProps: {
      options: [],
      isRequired: true,
      rules: requiredValidator,
      validate: validateMinRequiredValueForDropdown,
      placeholder: i18n.t('components.loanVariablesModal.modals.netTradeIn.selectPlaceholder'),
      labelWithoutAsterisk: true,
    },
  } as IField,
  {
    name: ADD_VEHICLE_FIELDS_NAMES.MILEAGE,
    component: Input,
    label: i18n.t('addVehicleModal.labels.mileage'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      isRequired: true,
      decimalScale: 0,
      rules: requiredValidator,
      maxLength: 7,
      validate: validateNumberValue,
      placeholder: i18n.t('components.input.placeholders.integer'),
      labelWithoutAsterisk: true,
    },
  },
  {
    name: ADD_VEHICLE_FIELDS_NAMES.RETAIL_PRICE,
    component: Input,
    label: i18n.t('addVehicleModal.labels.retailPrice'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      isRequired: true,
      decimalScale: 0,
      rules: requiredValidator,
      maxLength: 11,
      validate: validateRequiredMinimumValue,
      startAdornment: <span>{MONEY_SYMBOL}</span>,
      placeholder: i18n.t('components.input.placeholders.integer'),
      hideInitZeroValue: true,
      labelWithoutAsterisk: true,
    },
  },
  {
    name: ADD_VEHICLE_FIELDS_NAMES.BOOK_VALUE,
    component: Input,
    label: i18n.t('addVehicleModal.labels.bookValue'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      isRequired: true,
      decimalScale: 0,
      rules: requiredValidator,
      maxLength: 11,
      validate: validateRequiredMinimumValue,
      startAdornment: <span>{MONEY_SYMBOL}</span>,
      placeholder: i18n.t('components.input.placeholders.integer'),
      hideInitZeroValue: true,
      labelWithoutAsterisk: true,
    },
  },
];
